import * as React from "react";

function SvgLeftArrowSmall(props) {
  return <svg width={7} height={12} viewBox="0 0 7 12" {...props}><path fill="currentColor" fillRule="evenodd" d="M.005 5.892c.025-.236.128-.459.296-.638L4.783.43c.284-.327.74-.485 1.187-.413.447.073.817.364.963.761a1.08 1.08 0 0 1-.259 1.145L2.884 6l3.79 4.077c.307.31.406.748.26 1.145-.147.397-.517.688-.964.76a1.302 1.302 0 0 1-1.187-.412L.301 6.746a1.091 1.091 0 0 1-.296-.854z" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/left-arrow-small_53ff5c.svg";
export { SvgLeftArrowSmall as ReactComponent };